import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React from 'react';

import { FormCard, FormPageContainer, FormPageHeader } from '@/components/PageLayout';
import { useListReturn } from '@/hooks/useListReturn';
import { ROUTES } from '@/routes/routes';

import { CreateHeroSlideForm } from './CreateHeroSlideForm';

export const CreateHeroSlidePage: React.FC = () => {
  const { goToList } = useListReturn(ROUTES.HERO_SLIDES);

  return (
    <FormPageContainer>
      <FormPageHeader>
        <Button type="text" icon={<ArrowLeftOutlined />} onClick={goToList} />
        <h2>Новий слайд</h2>
      </FormPageHeader>
      <FormCard>
        <CreateHeroSlideForm />
      </FormCard>
    </FormPageContainer>
  );
};
